











































import {Component, Vue} from "vue-property-decorator";
import AMapLoader from '@amap/amap-jsapi-loader';
import GPS from "@/utils/GpstoGD";
import {PunchInfoDto} from "@/dto/PunchInfoDto";
import {PunchInfo} from "@/entity/PunchInfo";
import {UserInfoEntity} from "@/entity/UserInfoEntity";
import {SecurityUtils} from "@/oauth/SecurityUtils";
import {CompanyPoint} from "@/entity/CompanyPoint";
import {CompanyInfo} from "@/entity/CompanyInfo";

@Component({
  components: {},
})

export default class MapContainer extends Vue {
  map: any
  companyLocation: any
  personLocation: any
  personLocation1: any
  circleRadius: any

  distance: any
  punchInfo = new CompanyPoint()

  su = SecurityUtils;
  nowTime: any;
  date='';
  time='';
  timer: any;
  workPunchTimeList: any;
  workPunchTimeFlag = 0;


  fanhui() {
    this.$router.push("/keShangSelect")
  }

  async initMap() {
    AMapLoader.load({
      key: "94a40e8965e9e1f59e93bb6cb0103ed2",             // 申请好的Web端开发者Key，首次调用 load 时必填
      version: "2.0",      // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
      plugins: ['AMap.Geolocation', 'AMap.Geocoder', 'AMap.Marker', 'AMap.Circle', 'AMap.GeometryUtil'],       // 需要使用的的插件列表，如比例尺'AMap.Scale'等
    }).then((AMap) => {
      this.map = new AMap.Map("container", {  //设置地图容器id
        // viewMode: "3D",    //是否为3D地图模式
        zoom: 18,           //初始化地图级别
        // center: this.center, //初始化地图中心点位置
      });
      const circle = new AMap.Circle({
        center: new AMap.LngLat(Number(this.punchInfo.pointLongitude), Number(this.punchInfo.pointLatitude)),  // 圆心位置
        radius: Number(this.punchInfo.pointRange), // 圆半径
        fillColor: 'rgba(103,182,255,.5)',   // 圆形填充颜色
        strokeColor: '#5898ff', // 描边颜色
        strokeWeight: 2, // 描边宽度
      });
      this.map.add(circle)
      const marker = new AMap.Marker({
        position: new AMap.LngLat(Number(this.punchInfo.pointLongitude), Number(this.punchInfo.pointLatitude)),
        offset: new AMap.Pixel(-10, -10),
        icon: '//vdata.amap.com/icons/b18/1/2.png', // 添加 Icon 图标 URL
        title: '公司'
      });
      this.map.add(marker);
      this.map.plugin('AMap.Geolocation', () => {
        const geolocation = new AMap.Geolocation({
          enableHighAccuracy: false,//是否使用高精度定位，默认:true
          timeout: 10000,          //超过10秒后停止定位，默认：无穷大
          maximumAge: 0,           //定位结果缓存0毫秒，默认：0
          convert: true,           //自动偏移坐标，偏移后的坐标为高德坐标，默认：true
          showButton: true,        //显示定位按钮，默认：true
          buttonPosition: 'LB',    //定位按钮停靠位置，默认：'LB'，左下角
          buttonOffset: new AMap.Pixel(10, 20),//定位按钮与设置的停靠位置的偏移量，默认：Pixel(10, 20)
          showMarker: true,        //定位成功后在定位到的位置显示点标记，默认：true
          showCircle: false,        //定位成功后用圆圈表示定位精度范围，默认：true
          panToLocation: true,     //定位成功后将定位到的位置作为地图中心点，默认：true
          zoomToAccuracy: false      //定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：false
        });
        this.map.addControl(geolocation);
        geolocation.getCurrentPosition(
            (state: any, result: any) => {
              if (state == 'complete') {
                this.personLocation1 = result.position
                this.distance = AMap.GeometryUtil.distance(this.personLocation1, this.companyLocation);
                console.log(this.personLocation1)
                console.log(this.distance)
                AMap.convertFrom(result.position, 'gps', function (status: any, result: any) {
                  if (result.info === 'ok') {
                    const lnglats = result.locations; // Array.<LngLat>
                    const geocoder = new AMap.Geocoder({})
                    const aa = lnglats
                    geocoder.getAddress(aa, function (status: any, result: any) {
                      if (status === 'complete' && result.info === 'OK') {
                        console.log('逆向地理解码', result)
                      }
                    })
                  }
                });
              }
            },
            (f: any) => {
              console.log(f)
            }
            ,
            {
              enableHighAccuracy: false,
              convert: true,
              maximumAge: 0,
              timeout: 4000
            }
        );
        geolocation.watchPosition(
            (state: any, result: any) => {
              if (state == 'complete') {
                this.personLocation1 = result.position
                this.distance = AMap.GeometryUtil.distance(this.personLocation1, this.companyLocation);
                console.log(this.personLocation1)
                console.log(this.distance)
                AMap.convertFrom(result.position, 'gps', (status: any, result: any) => {
                  if (result.info === 'ok') {
                    const lnglats = result.locations; // Array.<LngLat>
                    console.log(lnglats + "逆转码的坐标")
                    this.personLocation = [result.locations[0].KL, result.locations[0].kT]
                    console.log(this.personLocation + '逆转码的坐标');
                    const geocoder = new AMap.Geocoder({})
                    const aa = lnglats
                    geocoder.getAddress(aa, (status: any, result: any) => {
                      if (status === 'complete' && result.info === 'OK') {
                        console.log('逆向地理解码', result)
                      }
                    })
                  }
                });
              }
            },
            (f: any) => {
              console.log(f)
            }
            ,
            {
              enableHighAccuracy: false,
              convert: true,
              maximumAge: 0,
              timeout: 1000
            }
        );
      });
    }).catch(e => {
      console.log(e);
    })
  }

  open1() {
    navigator.geolocation.getCurrentPosition((e: any) => {
      const a = GPS.gcjEncrypt((e.coords.latitude), (e.coords.longitude))
    }, (e: any) => {
      console.log(e)
    });
  }

  getNowDate() {
    const date = new Date();
    const sign2 = ":";
    const year = date.getFullYear(); // 年
    let month = date.getMonth() + 1; // 月
    let day = date.getDate(); // 日
    let hour = date.getHours(); // 时
    let minutes = date.getMinutes(); // 分
    let seconds = date.getSeconds(); //秒
    const weekArr = ['星期一', '星期二', '星期三', '星期四', '星期五', '星期六', '星期天'];
    const week = weekArr[date.getDay()];
    // 给一位数的数据前面加 “0”
    if (month >= 1 && month <= 9) {
      month = "0" + month as any;
    }
    if (day >= 0 && day <= 9) {
      day = "0" + day as any;
    }
    if (hour >= 0 && hour <= 9) {
      hour = "0" + hour as any;
    }
    if (minutes >= 0 && minutes <= 9) {
      minutes = "0" + minutes as any;
    }
    if (seconds >= 0 && seconds <= 9) {
      seconds = "0" + seconds as any;
    }
    this.nowTime = year + "-" + month + "-" + day + " " + hour + sign2 + minutes + sign2 + seconds;
  }

  getdate() {
    const weeks = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
    const time = new Date();
    const year = time.getFullYear();
    const month = time.getMonth() + 1;
    const day = time.getDate();
    const week = weeks[time.getDay()];
    this.getTime();
    this.date = year + '/' + month + '/' + day + " " + week;
  }

  getTime() {
    const time = new Date();
    const hour = time.getHours();
    let minutes = time.getMinutes();
    if (minutes < 10) {
      minutes = '0' + minutes as any
    }
    this.time = hour + ":" + minutes
  }

  clockIn() {
    if (this.distance < Number(this.punchInfo.pointRange)) {
      alert("打卡成功")
      /*
      const aa = localStorage.getItem("demo1") as any
      const company = JSON.parse(aa)
       */
      const companyInfo = JSON.parse(localStorage.getItem("selectedCompanyInfo") as  any) as CompanyInfo;
      const a = new PunchInfo()
      a.userName = this.su.getLoginUser().username.toString()
      a.companyId = companyInfo.companyId;
      a.punchPointId = this.punchInfo.id.toString()
      // a.punchLongitude = '120.71332172285932'
      a.punchLongitude = this.personLocation1[0].toString
      a.punchLatitude = this.personLocation1[1].toString
      // a.punchLatitude = '31.841466340248772'
      this.getNowDate()
      a.punchDate = this.nowTime.toString()
      PunchInfoDto.insertPunchInfoByReq(a)
    } else {
      alert("打卡失败")
    }
  }

  async getCompanyPoint() {
    const punChInfo = new PunchInfo()
    /*
    const a = localStorage.getItem("demo1") as any
    const company = JSON.parse(a)
     */
    const companyInfo = JSON.parse(localStorage.getItem("selectedCompanyInfo") as  any) as CompanyInfo;
    punChInfo.companyId = companyInfo.companyId
    punChInfo.userName = this.su.getLoginUser().username.toString();
    this.punchInfo = await PunchInfoDto.queryPunchInfoByUserNameAndCompanyId(punChInfo)
    this.companyLocation = [Number(this.punchInfo.pointLongitude), Number(this.punchInfo.pointLatitude)]
    console.log(this.punchInfo)
  }
  async getPunchInfoRecord(){
    const punChInfo = new PunchInfo()
    /*
    const a = localStorage.getItem("demo1") as any
    const company = JSON.parse(a)
    */
    const companyInfo = JSON.parse(localStorage.getItem("selectedCompanyInfo") as  any) as CompanyInfo;
    punChInfo.companyId = companyInfo.companyId
    punChInfo.userName = this.su.getLoginUser().username.toString();
    const aa = await PunchInfoDto.queryPunchInfoRecordByUserNameAndCompanyId(punChInfo) as any
    if (aa.length>=1){
      this.workPunchTimeFlag = 1  //有打卡记录
      this.workPunchTimeList = aa
    }else {
      this.workPunchTimeFlag = 0
    }
  }

  private mounted() {
    this.getdate();
    this.getPunchInfoRecord()
    this.timer = setInterval(() => {
      this.getdate();
    }, 3000)
    this.getCompanyPoint()
    this.initMap()
  }
}
